import { useLang } from "@/context/LanguageContext";

/** SVG sparkline for a small series of values (oldest → newest). */
export default function Sparkline({ values = [], width = 90, height = 28, positiveGood = true }) {
  const { lang } = useLang();
  const clean = values.map((v) => (typeof v === "number" && !Number.isNaN(v) ? v : null));
  const nonNull = clean.filter((v) => v !== null);
  if (nonNull.length < 2) {
    return (
      <svg width={width} height={height} className="opacity-40">
        <line x1="0" y1={height / 2} x2={width} y2={height / 2} stroke="#CBD5E1" strokeDasharray="2 2" />
      </svg>
    );
  }
  const min = Math.min(...nonNull);
  const max = Math.max(...nonNull);
  const span = max - min || Math.abs(max) || 1;
  const stepX = width / (clean.length - 1);
  const points = clean.map((v, i) => {
    if (v === null) return null;
    const x = i * stepX;
    const y = height - ((v - min) / span) * (height - 4) - 2;
    return { x, y, v };
  });
  const pathPoints = points.filter((p) => p !== null);
  if (pathPoints.length < 2) return null;

  const first = nonNull[0];
  const last = nonNull[nonNull.length - 1];
  const trendUp = last > first;
  // For "positiveGood" metrics: green when growing; for lower-is-better (e.g. debt_ratio): green when shrinking
  const good = positiveGood ? trendUp : !trendUp;
  const stroke = last === first ? "#94A3B8" : good ? "#15803D" : "#DC2626";

  const d = pathPoints
    .map((p, i) => (i === 0 ? `M ${p.x.toFixed(1)} ${p.y.toFixed(1)}` : `L ${p.x.toFixed(1)} ${p.y.toFixed(1)}`))
    .join(" ");

  const lastPt = pathPoints[pathPoints.length - 1];
  const title = lang === "it"
    ? `${values.length} punti · da ${first?.toLocaleString?.("it-IT") || first} a ${last?.toLocaleString?.("it-IT") || last}`
    : `${values.length} points · from ${first} to ${last}`;

  return (
    <svg width={width} height={height} className="overflow-visible" role="img" aria-label={title}>
      <title>{title}</title>
      <path d={d} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={lastPt.x} cy={lastPt.y} r="2.2" fill={stroke} />
    </svg>
  );
}
